export const MACRO_ACTION_TYPES = [
  {
    key: 'assign_team',
    label: 'ASSIGN_TEAM',
    inputType: 'search_select',
    attributeI18nKey: 'MACROS.ACTION.ASSIGN_TEAM',
  },
  {
    key: 'assign_agent',
    label: 'ASSIGN_AGENT',
    inputType: 'search_select',
    attributeI18nKey: 'MACROS.ACTION.ASSIGN_AGENT',
  },
  {
    key: 'add_label',
    label: 'ADD_LABEL',
    inputType: 'multi_select',
    attributeI18nKey: 'MACROS.ACTION.ADD_LABEL',
  },
  {
    key: 'remove_label',
    label: 'REMOVE_LABEL',
    inputType: 'multi_select',
    attributeI18nKey: 'MACROS.ACTION.REMOVE_LABEL',
  },
  {
    key: 'remove_assigned_agent',
    label: 'REMOVE_ASSIGNED_AGENT',
    inputType: null,
  },
  {
    key: 'remove_assigned_team',
    label: 'REMOVE_ASSIGNED_TEAM',
    inputType: null,
    attributeI18nKey: 'MACROS.ACTION.REMOVE_ASSIGNED_TEAM',
  },
  {
    key: 'send_email_transcript',
    label: 'SEND_EMAIL_TRANSCRIPT',
    inputType: 'email',
    attributeI18nKey: 'MACROS.ACTION.SEND_EMAIL_TRANSCRIPT',
  },
  {
    key: 'mute_conversation',
    label: 'MUTE_CONVERSATION',
    inputType: null,
    attributeI18nKey: 'MACROS.ACTION.MUTE_CONVERSATION',
  },
  {
    key: 'snooze_conversation',
    label: 'SNOOZE_CONVERSATION',
    inputType: null,
    attributeI18nKey: 'MACROS.ACTION.SNOOZE_CONVERSATION',
  },
  {
    key: 'resolve_conversation',
    label: 'RESOLVE_CONVERSATION',
    inputType: null,
    attributeI18nKey: 'MACROS.ACTION.RESOLVE_CONVERSATION',
  },
  {
    key: 'send_attachment',
    label: 'SEND_ATTACHMENT',
    inputType: 'attachment',
    attributeI18nKey: 'MACROS.ACTION.SEND_ATTACHMENT',
  },
  {
    key: 'send_message',
    label: 'SEND_MESSAGE',
    inputType: 'textarea',
    attributeI18nKey: 'MACROS.ACTION.SEND_MESSAGE',
  },
  {
    key: 'add_private_note',
    label: 'ADD_PRIVATE_NOTE',
    inputType: 'textarea',
    attributeI18nKey: 'MACROS.ACTION.SEND_PRIVATE_MESSAGE',
  },
  {
    key: 'change_priority',
    label: 'CHANGE_PRIORITY',
    inputType: 'search_select',
    attributeI18nKey: 'MACROS.ACTION.CHANGE_PRIORITY',
  },
  {
    key: 'send_webhook_event',
    label: 'SEND_WEBHOOK_EVENT',
    inputType: 'url',
  },
];
